import protoRoot from "../proto-root";
import ActivityLogEvent from "src/modules/communication-protobuf/private/ActivityLogEvent";
import debug from "src/modules/debug-logger";

import protobuf from "protobufjs";

// const protobuf = window.require("protobufjs");

function create({
  monitoringId,
  version = 1,
  startDate,
  duration,
  deviceName,
  avatarId,
  events = [],
  storageId,
  freemium
}) {
  const ActivityLogSession = protoRoot.lookupType(`comm.ActivityLogSession`);
  const StringValue = protoRoot.lookupType("comm.StringValue");

  const payload = {
    monitoringId,
    version,
    startDate,
    duration,
    deviceName,
    avatarId: StringValue.create({ value: avatarId }),
    events: events.map((event) => ActivityLogEvent.create(event)),
    storageId,
    freemium
  };

  const error = ActivityLogSession.verify(payload);
  if (error) {
    debug.protoBuffers(error);
    throw new Error(error);
  }
  return ActivityLogSession.create(payload);
}

function createAndEncode(payload) {
  const activityLogSession = create(payload);
  const ActivityLogSession = protoRoot.lookupType(`comm.ActivityLogSession`);

  const buffer = ActivityLogSession.encode(activityLogSession).finish();
  debug.protoBuffers("EnvelopeBuffer created", buffer);

  return protobuf.util.base64.encode(buffer, 0, buffer.length);
}

export default {
  create,
  createAndEncode
};

/* 
message ActivityLogSession {
  string monitoringId = 1;            // objectId - server one
  int32 version = 2;                  // version of AL
  string startDate = 10;
  int64 duration = 11;                // in ms
  string deviceName = 12;
  StringValue avatarId = 13;          // objectId - server one
  bool cleaned = 14;
  string storageId = 15;              // S3 storage id
  bool freemium = 16;
  repeated ActivityLogEvent events = 20;  // array of events
}
 */
